import { useEffect, useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";

import GeneralTab from "../accountSettingsScreens/GeneralTab";
import Notifications from "../accountSettingsScreens/Notifications";
import Verification from "../accountSettingsScreens/Verification";
import PayMethod from "../accountSettingsScreens/PayMethod"
import SecurityPage from "../accountSettingsScreens/SecurityTab";

import "../../assets/style/AccountSettings.css"

const tabMap = {
  general: 0,
  notifications: 1,
  verification: 2,
  payment: 3,
  security: 4,
};

const getTabFromSearch = (search) => {
  const tab = new URLSearchParams(search).get("tab");
  return tabMap[tab] ?? 0;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`setting-tabpanel-${index}`}
      aria-labelledby={`setting-tab-${index}`}
      className="tab-panel"
      {...other}
    >
      {value === index && <Box className="account-setting__tab-panel">{children}</Box>}
    </div>
  );
}

export default function AccountSettings() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => getTabFromSearch(location.search));
  const { t } = useLanguage();

  useEffect(() => {
    setActiveTab(getTabFromSearch(location.search));
  }, [location.search]);

  useEffect(() => {
    if (!location.hash) {
      return undefined;
    }

    const scrollTimer = window.setTimeout(() => {
      const target = document.getElementById(location.hash.slice(1));

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 120);

    return () => window.clearTimeout(scrollTimer);
  }, [activeTab, location.hash]);

  const handleChange = (_event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Paper elevation={0} sx={{ width: "100%", bgcolor: "transparent", borderRadius: "16px", padding:"0px"}} className="">
        <Box sx={{ borderBottom: 1, borderColor: "divider"}} className="account-setting__top-panel">
          <Box sx={{ 
            overflowX: 'auto', 
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none'
          }}>
            <Tabs
              value={activeTab}
              onChange={handleChange}
              aria-label="settings tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                minWidth: '100%',
                "& .MuiTab-root": {
                  textTransform: "none",
                  color: "text.secondary",
                  minWidth: 'auto',
                  padding: '12px 16px',
                  '@media (max-width: 768px)': {
                    padding: '8px 12px',
                    fontSize: '0.875rem'
                  }
                },
                "& .Mui-selected": { color: "white !important" },
                "& .MuiTabs-scrollButtons": {
                  color: "white",
                  '@media (max-width: 768px)': {
                    display: 'flex'
                  }
                }
              }}
            >
          <Tab
            icon={<AccountCircleOutlinedIcon />}
            iconPosition="start"
            label={t('general')}
          />
          <Tab
            icon={<NotificationsOutlinedIcon />}
            iconPosition="start"
            label={t('notifications')}
          />
          <Tab
            icon={<VerifiedUserOutlinedIcon />}
            iconPosition="start"
            label={t('verification')}
          />
          <Tab
            icon={<AccountBalanceWalletOutlinedIcon />}
            iconPosition="start"
            label={t('paymentMethods')}
          />
          <Tab
            icon={<SecurityOutlinedIcon />}
            iconPosition="start"
            label={t('security')}
          />
                    </Tabs>
          </Box>
        </Box>

      <TabPanel value={activeTab} index={0} >
        <GeneralTab setActiveTab={setActiveTab}/>
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <Notifications />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <Verification />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>        
        <PayMethod />
      </TabPanel>
      <TabPanel value={activeTab} index={4}>
        <SecurityPage />
      </TabPanel>
    </Paper>
  );
}
